// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".route-title-icon[data-v-300bda40] {\n  width: 43px;\n  height: 43px;\n  padding: 5px;\n  border-radius: 50%;\n  border: 1px solid #edf5f4;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
